// Module
var code = "<branch-terms kind=\"'paymentTerms'\"></branch-terms>\n";
// Exports
module.exports = code;